export class LocationDataModel {
    LocationCode: string;
    LocationNames: string;

}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/Model/booking/locationdatamodel.ts